var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61341 8.47551C1.52263 8.33171 1.47723 8.25984 1.45181 8.14897C1.43273 8.06571 1.43273 7.93437 1.45181 7.85111C1.47723 7.74024 1.52263 7.66837 1.61341 7.52457C2.36369 6.3366 4.59694 3.33337 8.00027 3.33337C11.4036 3.33337 13.6369 6.3366 14.3871 7.52457C14.4779 7.66837 14.5233 7.74024 14.5487 7.85111C14.5678 7.93437 14.5678 8.06571 14.5487 8.14897C14.5233 8.25984 14.4779 8.33171 14.3871 8.47551C13.6369 9.66351 11.4036 12.6667 8.00027 12.6667C4.59694 12.6667 2.36369 9.66351 1.61341 8.47551Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00026 10C9.10486 10 10.0003 9.1046 10.0003 8C10.0003 6.8954 9.10486 6 8.00026 6C6.89566 6 6.00026 6.8954 6.00026 8C6.00026 9.1046 6.89566 10 8.00026 10Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeNew);
export default __webpack_public_path__ + "static/media/eye_new.ec2972de58c57d92f7265fc9c7f976c3.svg";
export { ForwardRef as ReactComponent };